module.exports = __webpack_public_path__ + "static/media/pic-10.bd7092f1.jpg";